import React from "react";
import { Form, Space } from "antd";
import { Setter } from "../Setter/Setter";
import { FieldContainer, FormLabel, StyledFormItem } from "../styled";
import { FieldProps } from "./types";
import {Field as FieldType} from "../../types";

export const Field: React.FC<FieldProps> = ({
  field,
  sectionName,
  itemName,
  isSelected,
  config,
  options,
  onSelect,
  getSetterConfig,  
  getOptions,      
  formValues,      
  visibleFields,
  // renderOperations,
}) => {
  const path = `setters.${sectionName}.${itemName}.${
    typeof field === "string" ? field : field.name
  }`;

  // 渲染单个setter
  const renderSetter = (field: FieldType) => {
    const config = getSetterConfig(field);
    if (!config || !visibleFields.has(config.name)) return null;

    return (
      <StyledFormItem
      key={config.name}
        name={config.name}
        label={<FormLabel>{config.title}</FormLabel>}
        // extra={renderOperations(config.operations, config.name)} // 添加操作按钮
      >
        <Setter
          config={{
            ...config,
            options,
          }}
        />
      </StyledFormItem>
    );
  };

 

  // 渲染组合型field
  const renderCompositeField = (composite: FieldType) => {
    if (typeof composite === 'string' || !composite.fields) return null;

    return (
      <StyledFormItem
        key={composite.name}
        label={<FormLabel>{composite.title}</FormLabel>}
        // extra={renderOperations(composite.operations, composite.name)} // 添加操作按钮
      >
        <Space>
          {composite.fields.map((subField) => {
            const subFieldName = typeof subField === 'string' ? subField : subField.name;
            const subConfig = getSetterConfig(subFieldName);
            if (!subConfig) return null;
            return (
              <Form.Item 
                key={subFieldName} 
                name={subConfig.name} 
                noStyle
              >
                <Setter
                  config={{
                    ...subConfig,
                    options: getOptions(subConfig, formValues),
                  }}
                />
              </Form.Item>
            );
          })}
        </Space>
      </StyledFormItem>
    );
  };

  return (
    <FieldContainer  className={isSelected ? 'selected' : ''}  onClick={() => onSelect(path)}>
      {typeof field === "string" ? renderSetter(field) : renderCompositeField(field)}
    </FieldContainer>
  );
};
